<script>
import axios from '@/utils/axios';

const DEFAULT_FORM = () => ({
  id: null,
  name: '',
  code: '',
  is_paid: true,
  color: '',
});

export default {
  inject: ['setLoading'],
  emits: ['updated'],
  data() {
    return {
      form: DEFAULT_FORM(),
      errors: {},
      deleteItem: null,
    };
  },
  methods: {
    add() {
      this.resetForm();
    },

    edit(item) {
      this.resetForm();
      this.form.id = item.id;
      this.form.name = item.name || '';
      this.form.code = item.code || '';
      this.form.is_paid = !!item.is_paid;
      this.form.color = item.color || '';
    },

    setDelete(item) {
      this.deleteItem = item;
    },

    buildPayload() {
      return {
        name: this.form.name,
        code: this.form.code,
        is_paid: this.form.is_paid,
        color: this.form.color || null,
      };
    },

    async save() {
      this.errors = {};
      this.setLoading(true);
      try {
        let response;
        if (this.form.id) {
          response = await axios.put(`/hrms/leave-types/${this.form.id}`, this.buildPayload());
        } else {
          response = await axios.post('/hrms/leave-types', this.buildPayload());
        }
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('hrm_leave_type_modal');
        this.resetForm();
      } catch (error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    async deleteLeaveType() {
      this.setLoading(true);
      try {
        const response = await axios.delete(`/hrms/leave-types/${this.deleteItem.id}`);
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('hrm_leave_type_delete_modal');
      } catch (error) {
        if (error.type === 'validation') {
          this.$swalToast(error.errors?.id?.[0] || error.message, 'error');
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    resetForm() {
      this.form = DEFAULT_FORM();
      this.errors = {};
    },
  },
};
</script>

<template>
  <!-- Add/Edit Modal -->
  <div class="modal fade" id="hrm_leave_type_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ form.id ? 'Edit' : 'Add' }} Leave Type</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-0">
            <div class="row">

              <!-- Name -->
              <div class="col-md-7 mb-3">
                <label class="form-label">Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.name" placeholder="e.g. Sick Leave" />
                <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
              </div>

              <!-- Code -->
              <div class="col-md-5 mb-3">
                <label class="form-label">Code <span class="text-danger">*</span></label>
                <input type="text" class="form-control text-uppercase" v-model="form.code" placeholder="e.g. SL" />
                <div v-if="errors.code" class="text-danger small mt-1">{{ errors.code[0] }}</div>
              </div>

              <!-- Color -->
              <div class="col-md-7 mb-3">
                <label class="form-label">Color</label>
                <div class="d-flex align-items-center gap-2">
                  <input type="color" class="form-control form-control-color" v-model="form.color" />
                  <input type="text" class="form-control" v-model="form.color" placeholder="#6366f1 (optional)" />
                  <button v-if="form.color" type="button" class="btn btn-light btn-sm" @click="form.color = ''">Clear</button>
                </div>
                <div v-if="errors.color" class="text-danger small mt-1">{{ errors.color[0] }}</div>
              </div>

              <!-- Is Paid -->
              <div class="col-md-5 mb-3">
                <label class="form-label d-block">Paid Leave?</label>
                <div class="form-check form-switch mt-2">
                  <input class="form-check-input" type="checkbox" role="switch" v-model="form.is_paid" id="ltIsPaid" />
                  <label class="form-check-label ms-1" for="ltIsPaid">{{ form.is_paid ? 'Paid' : 'Unpaid' }}</label>
                </div>
                <div v-if="errors.is_paid" class="text-danger small mt-1">{{ errors.is_paid[0] }}</div>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary">{{ form.id ? 'Update' : 'Save' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="hrm_leave_type_delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">You want to delete this leave type? This can't be undone.</p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteLeaveType">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>